import { Typography, Box, Container, Paper, Button } from '@mui/material';
import { FC, useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router';
import SuccessIcon from '@acorn-portal/shared/src/assets/shared/icons/circled-check-green.svg?react';
import { formatCurrency } from '@acorn-portal/shared/src/utils/formatter';
import HomeIcon from '@mui/icons-material/Home';
import { ROUTE_PATHS } from '@acorn-portal/shared/src/utils/Routes';
import AcornBanner from '@acorn-portal/shared/src/components/banner/AcornLanderBanner';
import extractBeforeDash from '@acorn-portal/shared/src/utils/extractBeforeDash';
import MotorcadeLanderBanner from '@acorn-portal/shared/src/components/banner/MotorcadeLanderBanner';
import CarrotLanderBanner from '@acorn-portal/shared/src/components/banner/CarrotLanderBanner';
import FlagLanderBanner from '@acorn-portal/shared/src/components/banner/FlagLanderBanner';

interface IState {
	amount: number;
}

type LocationProps = {
	state: {
		amount: number;
	};
};

const CancelledWithDebtPaymentConfirmation: FC = () => {
	const location = useLocation() as unknown as LocationProps;
	const navigate = useNavigate();
	const [locationState, setLocationState] = useState<IState | undefined>();

	useEffect(() => {
		if (locationState?.amount && locationState?.amount <= 0) {
			navigate(ROUTE_PATHS.home, { replace: true });
		} else {
			setLocationState({
				amount: location.state.amount,
			});
		}
	}, [locationState]);

	const company = extractBeforeDash(import.meta.env.VITE_JOURNEY || '');

	const LandingBanner = () => {
		switch (company) {
			case 'MOTORCADE':
				return <MotorcadeLanderBanner text='Thank you for your payment!' />;
			case 'CARROT':
				return <CarrotLanderBanner text='Thank you for your payment!' />;
			case 'FLAG':
				return <FlagLanderBanner text='Thank you for your payment!' />;
			default:
				return <AcornBanner text='Thank you for your payment!' />;
		}
	};

	return (
		<Paper
			sx={{
				borderRadius: '8px',
				paddingBottom: 3,
			}}
		>
			<LandingBanner />
			<Container maxWidth='sm' sx={{ textAlign: 'center' }}>
				<Box my={4}>
					{location?.state.amount && (
						<Typography variant='h6' color='secondary.main' paddingBottom={1}>
							Your payment of {formatCurrency(location?.state.amount)} has been taken.
						</Typography>
					)}
					<Box
						sx={{
							'& svg': {
								maxHeight: '120px',
								margin: '1.2rem',
								'.cls-1': {
									fill: '#2e7d32',
								},
							},
						}}
					>
						<SuccessIcon />
					</Box>
					<Typography align='center' sx={{ fontWeight: 600, marginTop: 1 }}>
						A receipt for this transaction has been sent via email for your records.
					</Typography>
					<Button
						variant='contained'
						fullWidth
						startIcon={<HomeIcon />}
						sx={{ my: 4 }}
						onClick={() => navigate(ROUTE_PATHS.home)}
					>
						Go Home
					</Button>
				</Box>
			</Container>
		</Paper>
	);
};

export default CancelledWithDebtPaymentConfirmation;
